export const MOCK_CONFLUENCE_SMART_LINK_TEST = {
	data: {
		graphStore: {
			cypherQueryV2: {
				edges: [
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'entity',
									value: {
										id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/6027622239',
										data: {
											__typename: 'ConfluencePage',
											ConfluencePage_createdAt: '2025-10-31T00:04:26.309Z',
											ConfluencePage_id:
												'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/6027622239',
											ConfluencePage_pageId: '6027622239',
											ConfluencePage_status: 'CURRENT',
											ConfluencePage_subtype: null,
											ConfluencePage_title: 'Teamwork Graph Labs Roadmap Q2',
											ConfluencePage_type: 'PAGE',
											ConfluencePage_ancestors: [
												{
													id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/2751272732',
												},
												{
													id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/3747787847',
												},
												{
													id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/4185525992',
												},
												{
													id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/4491170307',
												},
											],
											ConfluencePage_author: {
												id: 'ari:cloud:identity::user/712020:a5e9d3e4-843b-4db9-ae21-1dfb9f00b015',
											},
											ConfluencePage_labels: [],
											ConfluencePage_links: {
												webUi: '/spaces/TEAMGRAPH/pages/6027622239/Teamwork+Graph+Labs+Roadmap+Q2',
												base: 'https://hello.atlassian.net/wiki',
											},
											ConfluencePage_owner: {
												id: 'ari:cloud:identity::user/712020:a5e9d3e4-843b-4db9-ae21-1dfb9f00b015',
											},
											ConfluencePage_space: {
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:space/2751272599',
											},
										},
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'entity',
									value: {
										id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/6015026713',
										data: {
											__typename: 'ConfluencePage',
											ConfluencePage_createdAt: '2025-10-29T01:12:20.519Z',
											ConfluencePage_id:
												'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/6015026713',
											ConfluencePage_pageId: '6015026713',
											ConfluencePage_status: 'CURRENT',
											ConfluencePage_subtype: null,
											ConfluencePage_title:
												'[Spike -2025-10-29] Inferred Teams/Projects - Scope and Initial Planning',
											ConfluencePage_type: 'PAGE',
											ConfluencePage_ancestors: [
												{
													id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/3590719330',
												},
												{
													id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/6014962199',
												},
												{
													id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/6014962495',
												},
											],
											ConfluencePage_author: {
												id: 'ari:cloud:identity::user/639985bcf7f0ee492fced7ab',
											},
											ConfluencePage_labels: [],
											ConfluencePage_links: {
												webUi:
													'/spaces/CAIMT/pages/6015026713/Spike+-2025-10-29+Inferred+Teams+Projects+-+Scope+and+Initial+Planning',
												base: 'https://hello.atlassian.net/wiki',
											},
											ConfluencePage_owner: {
												id: 'ari:cloud:identity::user/639985bcf7f0ee492fced7ab',
											},
											ConfluencePage_space: {
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:space/3590718239',
											},
										},
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'entity',
									value: {
										id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/5934588761',
										data: {
											__typename: 'ConfluencePage',
											ConfluencePage_createdAt: '2025-10-08T18:29:45.396Z',
											ConfluencePage_id:
												'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/5934588761',
											ConfluencePage_pageId: '5934588761',
											ConfluencePage_status: 'CURRENT',
											ConfluencePage_subtype: 'LIVE',
											ConfluencePage_title: 'TWG India ITG December 2-5 2025',
											ConfluencePage_type: 'PAGE',
											ConfluencePage_ancestors: [
												{
													id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/3754575594',
												},
											],
											ConfluencePage_author: {
												id: 'ari:cloud:identity::user/712020:d5f5b7b6-42a2-4d4c-aec3-4fe9d371228b',
											},
											ConfluencePage_labels: [],
											ConfluencePage_links: {
												webUi:
													'/spaces/~712020d5f5b7b642a24d4caec34fe9d371228b/pages/5934588761/TWG+India+ITG+December+2-5+2025',
												base: 'https://hello.atlassian.net/wiki',
											},
											ConfluencePage_owner: {
												id: 'ari:cloud:identity::user/712020:d5f5b7b6-42a2-4d4c-aec3-4fe9d371228b',
											},
											ConfluencePage_space: {
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:space/3754574642',
											},
										},
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'entity',
									value: {
										id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/6081906453',
										data: {
											__typename: 'ConfluencePage',
											ConfluencePage_createdAt: '2025-11-12T19:06:21.576Z',
											ConfluencePage_id:
												'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/6081906453',
											ConfluencePage_pageId: '6081906453',
											ConfluencePage_status: 'CURRENT',
											ConfluencePage_subtype: null,
											ConfluencePage_title: 'TWG MCP Tools E2E Integration and Quality Improvement',
											ConfluencePage_type: 'PAGE',
											ConfluencePage_ancestors: [
												{
													id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/3854546048',
												},
											],
											ConfluencePage_author: {
												id: 'ari:cloud:identity::user/712020:7d53965e-4356-404e-a24c-41dd53ab03a8',
											},
											ConfluencePage_labels: [],
											ConfluencePage_links: {
												webUi:
													'/spaces/~7120207d53965e4356404ea24c41dd53ab03a8/pages/6081906453/TWG+MCP+Tools+E2E+Integration+and+Quality+Improvement',
												base: 'https://hello.atlassian.net/wiki',
											},
											ConfluencePage_owner: {
												id: 'ari:cloud:identity::user/712020:7d53965e-4356-404e-a24c-41dd53ab03a8',
											},
											ConfluencePage_space: {
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:space/3854545024',
											},
										},
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'entity',
									value: {
										id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/6111888415',
										data: {
											__typename: 'ConfluencePage',
											ConfluencePage_createdAt: '2025-11-20T01:49:20.046Z',
											ConfluencePage_id:
												'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/6111888415',
											ConfluencePage_pageId: '6111888415',
											ConfluencePage_status: 'CURRENT',
											ConfluencePage_subtype: null,
											ConfluencePage_title: 'Technical exploration for TWG API direct access',
											ConfluencePage_type: 'PAGE',
											ConfluencePage_ancestors: [
												{
													id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/2751272732',
												},
												{
													id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/5137944581',
												},
												{
													id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/5476982327',
												},
											],
											ConfluencePage_author: {
												id: 'ari:cloud:identity::user/557058:fb4ff437-1a00-4a87-a694-cf4225d11f39',
											},
											ConfluencePage_labels: [],
											ConfluencePage_links: {
												webUi:
													'/spaces/TEAMGRAPH/pages/6111888415/Technical+exploration+for+TWG+API+direct+access',
												base: 'https://hello.atlassian.net/wiki',
											},
											ConfluencePage_owner: {
												id: 'ari:cloud:identity::user/557058:fb4ff437-1a00-4a87-a694-cf4225d11f39',
											},
											ConfluencePage_space: {
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:space/2751272599',
											},
										},
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'entity',
									value: {
										id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/181621547',
										data: {
											__typename: 'ConfluencePage',
											ConfluencePage_createdAt: '2015-03-18T00:03:23.525Z',
											ConfluencePage_id:
												'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/181621547',
											ConfluencePage_pageId: '181621547',
											ConfluencePage_status: 'CURRENT',
											ConfluencePage_subtype: null,
											ConfluencePage_title: 'Atlassian Holidays',
											ConfluencePage_type: 'PAGE',
											ConfluencePage_ancestors: [
												{
													id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/798990863',
												},
												{
													id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/181601262',
												},
												{
													id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/839135181',
												},
											],
											ConfluencePage_author: {
												id: 'ari:cloud:identity::user/557057:1cd20937-9116-4db6-bf95-85783e0694e0',
											},
											ConfluencePage_labels: [
												{ id: '131972409' },
												{ id: '130253643' },
												{ id: '128648740' },
												{ id: '1395740466' },
												{ id: '1509803483' },
												{ id: '1589760598' },
												{ id: '2537529081' },
												{ id: '2537558973' },
												{ id: '2982906218' },
												{ id: '2982939150' },
											],
											ConfluencePage_links: {
												webUi: '/spaces/GDAY/pages/181621547/Atlassian+Holidays',
												base: 'https://hello.atlassian.net/wiki',
											},
											ConfluencePage_owner: {
												id: 'ari:cloud:identity::user/557057:1cd20937-9116-4db6-bf95-85783e0694e0',
											},
											ConfluencePage_space: {
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:space/798990818',
											},
										},
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'entity',
									value: {
										id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/4899082508',
										data: {
											__typename: 'ConfluencePage',
											ConfluencePage_createdAt: '2025-02-21T22:04:58.078Z',
											ConfluencePage_id:
												'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/4899082508',
											ConfluencePage_pageId: '4899082508',
											ConfluencePage_status: 'CURRENT',
											ConfluencePage_subtype: null,
											ConfluencePage_title: 'Issue Has Assignee Cypher Query via GraphQL E2E Test',
											ConfluencePage_type: 'PAGE',
											ConfluencePage_ancestors: [
												{
													id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/2751272732',
												},
												{
													id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/3747787847',
												},
												{
													id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/4705173354',
												},
												{
													id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/1487059712',
												},
												{
													id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/1802529362',
												},
												{
													id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/4898829664',
												},
											],
											ConfluencePage_author: {
												id: 'ari:cloud:identity::user/5cc8e95bc07bd90e5ec16348',
											},
											ConfluencePage_labels: [
												{ id: '5075646486' },
												{ id: '5075895024' },
												{ id: '127693702' },
											],
											ConfluencePage_links: {
												webUi:
													'/spaces/TEAMGRAPH/pages/4899082508/Issue+Has+Assignee+Cypher+Query+via+GraphQL+E2E+Test',
												base: 'https://hello.atlassian.net/wiki',
											},
											ConfluencePage_owner: {
												id: 'ari:cloud:identity::user/5cc8e95bc07bd90e5ec16348',
											},
											ConfluencePage_space: {
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:space/2751272599',
											},
										},
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'entity',
									value: {
										id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/6121977440',
										data: {
											__typename: 'ConfluencePage',
											ConfluencePage_createdAt: '2025-11-23T22:35:53.772Z',
											ConfluencePage_id:
												'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/6121977440',
											ConfluencePage_pageId: '6121977440',
											ConfluencePage_status: 'CURRENT',
											ConfluencePage_subtype: null,
											ConfluencePage_title: 'Exposing TWG Context APIs to Atlassian MCP Server',
											ConfluencePage_type: 'PAGE',
											ConfluencePage_ancestors: [
												{
													id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/3079538288',
												},
												{
													id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/373537543',
												},
												{
													id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/5892048648',
												},
											],
											ConfluencePage_author: {
												id: 'ari:cloud:identity::user/557058:e9d42ec6-1656-4d0d-8871-0c8e86d3148d',
											},
											ConfluencePage_labels: [],
											ConfluencePage_links: {
												webUi:
													'/spaces/AGG/pages/6121977440/Exposing+TWG+Context+APIs+to+Atlassian+MCP+Server',
												base: 'https://hello.atlassian.net/wiki',
											},
											ConfluencePage_owner: {
												id: 'ari:cloud:identity::user/557058:e9d42ec6-1656-4d0d-8871-0c8e86d3148d',
											},
											ConfluencePage_space: {
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:space/3079537814',
											},
										},
									},
								},
							],
						},
					},
				],
			},
		},
	},
	extensions: {
		gateway: {
			request_id: 'confluence-smart-link-test-request-id',
			trace_id: 'confluence-smart-link-test-trace-id',
			crossRegion: false,
			edgeCrossRegion: false,
		},
	},
} as const;
